import imagesMetaData from "@/../.sourceflow/image_metadata.json";
import { transformImageUrl } from "@/functions/transformImageUrl";

let cache = null;

/**
 * Returns the CMS image metadata with every src normalized via
 * transformImageUrl, computed once and reused across renders.
 *
 * @returns {Object}
 */
export const getTransformedImagesMetaData = () => {
  if (!cache) {
    cache = Object.fromEntries(
      Object.entries(imagesMetaData).map(([key, value]) => [key, { ...value, src: transformImageUrl(value?.src) }])
    );
  }

  return cache;
};
